/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {TemplatesContent} from './TemplatesContent';

/**
 * The TemplatesTemplateIdBody model module.
 * @module model/TemplatesTemplateIdBody
 * @version 1.0.0
 */
export class TemplatesTemplateIdBody {
  /**
   * Constructs a new <code>TemplatesTemplateIdBody</code>.
   * @alias module:model/TemplatesTemplateIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TemplatesTemplateIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TemplatesTemplateIdBody} obj Optional instance to populate.
   * @return {module:model/TemplatesTemplateIdBody} The populated <code>TemplatesTemplateIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TemplatesTemplateIdBody();
      if (data.hasOwnProperty('propertyId'))
        obj.propertyId = ApiClient.convertToType(data['propertyId'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('content'))
        obj.content = TemplatesContent.constructFromObject(data['content']);
    }
    return obj;
  }
}

/**
 * @member {String} propertyId
 */
TemplatesTemplateIdBody.prototype.propertyId = undefined;

/**
 * @member {String} title
 */
TemplatesTemplateIdBody.prototype.title = undefined;

/**
 * @member {String} description
 */
TemplatesTemplateIdBody.prototype.description = undefined;

/**
 * @member {module:model/TemplatesContent} content
 */
TemplatesTemplateIdBody.prototype.content = undefined;

